import(/* webpackMode: "eager" */ "/vercel/path0/src/app/technologies/page.tsx");
